import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=dcc08dde&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcc08dde')) {
      api.createRecord('dcc08dde', component.options)
    } else {
      api.reload('dcc08dde', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=dcc08dde&", function () {
      api.rerender('dcc08dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27NOgR4O4bprm/JS/cancellationPolicy.vue"
export default component.exports